// extracted by mini-css-extract-plugin
export default {"dlEntityLink":"src-js-containers-file-components-EntityLink---dlEntityLink---x1tq9","dlEntityLinkLayout":"src-js-containers-file-components-EntityLink---dlEntityLinkLayout----wvWe"};